export default __webpack_public_path__ + "static/media/ic-nav.50cd942a.svg";